import isNil from 'lodash/isNil';
import React from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import NPIFields from 'pages/Dashboard/components/NPIFields';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Button from 'pages/Dashboard/components/Button';
import {
  NpiDTO,
} from 'dtos/npiDTO';

export const npiDefaultValues: NpiDTO = {
  number: '',
  taxonomyCode: '',
};

type Props = {
  required?: boolean;
};

export default function NPI({ required = false }: Props) {
  const {
    watch,
    setValue,
    trigger,
  } = useFormContext();

  const npi = watch('npi');

  return isNil(npi) && !required ? (
    <Button
      variant="text"
      color="primary"
      onClick={() => {
        setValue('npi', npiDefaultValues);
      }}
      className="flex items-center gap-1 !text-xs !font-medium"
    >
      <AddIcon className="!w-5 !h-5 !text-inherit" />
      Add NPI
    </Button>
  ) : (
    <div className="flex gap-2 items-end">
      <NPIFields required={required} />
      {!required && (
      <IconButton
        size="small"
        className="!h-7 !w-7 relative -top-1"
        onClick={() => {
          setValue('npi', undefined);
          trigger();
        }}
      >
        <CloseIcon className="!w-5 !h-5 !text-gray-500" />
      </IconButton>
      )}
    </div>
  );
}
